<template>
	<div class="container">
		<div class="form__wrapper">
			<div class="form__title">
				Employer Registration
			</div>
			<div class="form__body">
				<div v-if="getErrorMessage" class="alert alert-danger" role="alert">
					{{getErrorMessage}}
				</div>
				<form @submit.prevent="registerUser">
                    <div class="form-row">
						<div class="col-md-6">
							<div class="form-group">
								<label for="fname">First Name</label>
								<input 
									id="fname"
									v-model="itemData.fname"
									class="form-control"
									:class="[{'is-invalid': errors.fname}]"
									@keydown="clearErrors($event.target.name)"
									type="text" 
									placeholder="First Name">
								<div class="invalid-feedback">
									{{ errors.fname }}
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label for="lname">Last Name</label>
								<input 
									id="lname"
									class="form-control"
									v-model="itemData.lname"
									:class="[{'is-invalid': errors.lname}]"
									@keydown="clearErrors($event.target.name)"
									type="text"
									placeholder="Last Name">
								<div class="invalid-feedback">
									{{ errors.lname }}
								</div>
							</div>
						</div>
					</div>

					<div class="form-row">
						<div class="col-md-12">
							<div class="form-group">
								<label for="email">Email Address</label>
								<input 
									id="email"
									class="form-control" 
									placeholder="Email Address" 
									type="email"
									v-model="itemData.email"
									:class="[{'is-invalid': errors.email}]"
									@keydown="clearErrors($event.target.name)">
								<div class="invalid-feedback">
									{{ errors.email }}
								</div>
							</div>
						</div>
					</div>

                    <div class="form-row">
						<div class="form-group col-md-6">
							<label for="password">Password</label>
							<input
								id="password"
								class="form-control"
								v-model="itemData.password"
								:class="[{'is-invalid': errors.password}]"
								@keydown="clearErrors($event.target.name)"
								type="password" 
								placeholder="********">
							<div class="invalid-feedback">
								{{ errors.password }}
							</div>
						</div>
						<div class="form-group col-md-6">
							<label for="phone">Phone Number</label>
							<input 
								id="phone"
								v-model="itemData.phone"
								:class="[{'is-invalid': errors.phone}]"
								@keydown="clearErrors($event.target.name)"
								type="text" 
								class="form-control" 
								placeholder="Phone Number">
							<div class="invalid-feedback">
								{{ errors.phone }}
							</div>
						</div>
					</div>

                    <hr />
                    
                    <div class="form-row">
						<div class="col-md-12">
							<div class="form-group">
								<label for="businesName">Business Name</label>
								<input 
									id="businessName"
									class="form-control" 
									placeholder="Business Name" 
									type="text"
									v-model="employer.business_name"
									:class="[{'is-invalid': errors.business_name}]"
									@keydown="clearErrors($event.target.business_name)">
								<div class="invalid-feedback">
									{{ errors.business_name }}
								</div>
							</div>
						</div>
					</div>

                    <div class="form-row">
						<div class="col-md-12">
							<div class="form-group">
								<label for="business-email">Business Email Address</label>
								<input 
									id="business-email"
									class="form-control" 
									placeholder="Email Address" 
									type="email"
									v-model="employer.email"
									:class="[{'is-invalid': errors.businessEmail}]"
									@keydown="clearErrors($event.target.name)">
								<div class="invalid-feedback">
									{{ errors.businessEmail }}
								</div>
							</div>
						</div>
					</div>

                    <div class="form-row">
						<div class="form-group col-md-6">
                            <label for="city">Business City</label>
                            <input 
                                id="city"
                                class="form-control" 
                                placeholder="City" 
                                type="text"
                                v-model="employer.city"
                                :class="[{'is-invalid': errors.city}]"
                                @keydown="clearErrors($event.target.city)">
                            <div class="invalid-feedback">
                                {{ errors.city }}
                            </div>
						</div>

                        <div class="form-group col-md-6">
							<label for="business-phone">Business Phone Number</label>
							<input 
								id="business-phone"
								v-model="employer.phone"
								:class="[{'is-invalid': errors.businessPhone}]"
								@keydown="clearErrors($event.target.businessPhone)"
								type="text" 
								class="form-control" 
								placeholder="Business Phone Number">
							<div class="invalid-feedback">
								{{ errors.businessPhone }}
							</div>
						</div>
					</div>

                    <div class="form-row">
						<div class="col-md-12">
							<div class="form-group">
								<label for="forum-body">Business Address</label>
								<textarea
									id="address"
									v-model="employer.address"
									@keydown="clearErrors($event.target.address)"
									title=""
									:class="[{ 'is-invalid': errors.address}]"
									class="input input--lg input--light"
									cols="30"
									rows="4"
									placeholder="Address">
								</textarea>
								<div class="invalid-feedback">
									{{ errors.address }}
								</div>
							</div>
						</div>
					</div>

					<div class="btn__group btn__group--form">
						<button
							type="submit"
							v-bind="{'disabled': loading}"
							@click.prevent="registerUser"
							class="btn__primary btn__primary--main">Sign Up</button>
					</div>
				</form>
				<div class="form__meta">
					<p>Already have an account?
						<router-link
							:to="{name: 'login'}" 
							class="form__link" exact>Sign In</router-link>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import form from '../mixins/form';
import auth from '../utils/validations/auth';

export default {
	name: 'EmployerRegistration',
	mixins: [form],
	data() {
		return {
			itemData: {},
			errors: {},
			loading: false,
			employer: {}
		};
	},
	created() {
		this.reset();
	},
	computed: {
		...mapGetters([
			'getRegistrationStatus',
			'getStatus',
			'getErrorMessage'
		])
	},
	watch: {
		getRegistrationStatus(value) {
			if (value) {
				this.clearErrors();
				this.$router.push('/');
				return true;
			}
		},
		loggedUser: (newValue, oldValue) => {
			if (newValue && newValue.length) {
				this.$router.push('/');		
			}
		},
		status: (newValue, oldValue) => {
			if (newValue) {
				this.loading = newValue === 'loading';
			}
		},
		isLoggedIn: (newValue, oldValue) => {
			if (newValue) {
				this.$router.push('/');
			}
		}
	},
	methods: {
		...mapActions([
			'register'
		]),
		...mapMutations([
			'reset'
		]),
		registerUser() {
			this.itemData.employer = this.employer;
			this.validate(this.itemData, auth.employer);
			if (Object.keys(this.issues).length > 0) {
				this.errors = this.issues;
				return false;
			}
			this.loading = true;
			this.register(this.itemData);
			this.$router.push('/');
			return true;
		}
	}
};
</script>

<style lang="scss" scoped>
	.btn__group--form {
		margin-top: 30px;
		text-align: center;
	}
	.btn__primary--main {
		width: 230px;
	}
</style>
